import Button from 'Shared/components/Button'
import Flash from 'Shared/components/Flash/components/Flash'
import { Formik, Form } from 'formik';
import IntervalInput from 'Shared/components/IntervalInput/IntervalInput';
import ServerWaitButton from 'Shared/components/ServerWaitButtonStandalone'
import './Form.scoped.scss'
import useAct from 'Workflows/hooks/useAct'

export default function EditDelayNode({ nodeId }) {
  const act = useAct()
  const [flash, setFlash] = useState(null)
  const properties = useSel(s => s.workflowNodes.entities[nodeId].properties)

  const handleSave = (values) => {
    return act.builder.updateNode({ nodeId, properties: values })
  }

  return (
    <Formik
      initialValues={properties}
      onSubmit={() => {}}
    >
      {({ values, setFieldValue }) => {
        return (
        <Form>
          {flash && <Flash message={flash.message} type={flash.type} onHide={() => setFlash(null)} />}

          <div className="fields">
            <div className="field">
              <p>Wait for</p>
              <IntervalInput
                value={values.delayInSeconds}
                onChange={(value) => setFieldValue('delayInSeconds', value)}
              />
            </div>
            <div className="field">
              <ServerWaitButton className="button small primary margin-right" onClick={() => handleSave(values)} saveButton>Save changes</ServerWaitButton>
              <Button small red onClick={() => act.local.setSidebar({ kind: 'workflow' })}>Cancel</Button>
            </div>
          </div >
        </Form>
      )}}
    </Formik>
  )
}
